import {UserState} from '../userState';
import {IAppState} from '../../core/redux/IAppState';


type UserStateAction = {
  type: string,
  payload: UserState
}

export const userStateAction = (payload: UserStateAction['payload']): UserStateAction => ({
  type: 'USER_STATE',
  payload: payload,
});

export const userStateReducer = (state: IAppState, action: UserStateAction): IAppState => {

  if (!action || action.type !== 'USER_STATE') return state;

  return {
    ...state,
    userState: action.payload
  };
};